<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-12-16 11:44:29
 * @LastEditors: pj
 * @LastEditTime: 2022-12-28 15:37:40
-->
<template>
    <a-card :title="c_title">
        <a-form-model :model="modalState" ref="ruleForm" :layout="formItemLayout" :labelCol="labelCol" :wrapperCol="wrapperCol">

            <a-form-model-item label="配置值" prop="configvalue">
                <editor v-model="modalState.configvalue" @init="editorInit" :lang="currentLanguage" theme="monokai" width="100%" height="400" style="font-size:15px;"></editor>
            </a-form-model-item>

            <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }">
                <a-button type="primary" @click="handleOk">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-card>
</template>
<script>
import Editor from 'vue2-ace-editor'
export default {
    data() {
        return {
            c_title: '全局配置',
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            currentLanguage: 'json',
            confirmLoading: false,
            formItemLayout: 'horizontal',
            modalState: {
                configvalue: '',
            },
        }
    },
    components: {
        Editor,
    },
    computed: {},
    methods: {
        editorInit() {
            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/xml')
            require('brace/mode/json')
            require('brace/mode/javascript') //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        handleOk() {
            this.confirmLoading = true
            console.log(this.modalState)
            //编辑
            this.$store
                .dispatch({
                    type: 'configcenter/editGlobal',
                    params: this.modalState,
                })
                .then((response) => {
                    console.log(response)
                    this.confirmLoading = false
                    this.handleCancel()
                })
        },
        handleCancel() {
            this.$router.back(-1)
        },
    },
    mounted() {
        this.confirmLoading = true
        this.c_title = '编辑配置'
        this.$store
            .dispatch({
                type: 'configcenter/queryGlobal',
                params: {},
            })
            .then((res) => {
                let result = res.data.data
                console.log(result)
                if (result) {
                    this.modalState.configvalue = result
                } else {
                    this.message.error('查询配置异常')
                }
            })
    },
}
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
</style>
